import React from 'react';
import parse from 'html-react-parser';

/**
 * Renders a list of product summary bullets.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {Array} props.bullets - The array of bullet points to render.
 * @returns {JSX.Element} The rendered component.
 */
const ProductSummaryList = ({ bullets }) => {
	const bulletText = bullets?.map((bullet, index) => {
		if (bullet) {
			return <li key={index}>{parse(bullet)}</li>;
		}
		return null;
	});

	return <ul className="prc__card--info-items">{bulletText}</ul>;
};

export default ProductSummaryList;
